var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNounStar1864272222222(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#222222;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M906,724.8L1152,522c34.8-28.8,16.8-85.2-28.8-87.6l-316.8-19.2c-19.2-1.2-36-13.2-43.2-31.2L646.8,86.4 c-16.8-42-75.6-42-92.4,0L438,382.8c-7.2,18-24,30-43.2,31.2l-318,19.2C31.2,435.6,13.2,492,48,520.8l246,201.6 c14.4,12,21.6,32.4,16.8,50.4l-80.4,308.4c-10.8,43.2,36,78,74.4,54l267.6-171.6c16.8-10.8,37.2-10.8,52.8,0L894,1135.2 c38.4,24,85.2-10.8,74.4-54L888,774C884.4,756,890.4,736.8,906,724.8L906,724.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounStar1864272222222);
export default __webpack_public_path__ + "static/media/noun-star-1864272-222222.50793d6bd70b98e70fea33c4371cd93b.svg";
export { ForwardRef as ReactComponent };